import { render, staticRenderFns } from "./BannerEdit.vue?vue&type=template&id=450dafde&scoped=true"
import script from "./BannerEdit.vue?vue&type=script&lang=js"
export * from "./BannerEdit.vue?vue&type=script&lang=js"
import style0 from "./BannerEdit.vue?vue&type=style&index=0&id=450dafde&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450dafde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('450dafde')) {
      api.createRecord('450dafde', component.options)
    } else {
      api.reload('450dafde', component.options)
    }
    module.hot.accept("./BannerEdit.vue?vue&type=template&id=450dafde&scoped=true", function () {
      api.rerender('450dafde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/components/BannerEdit.vue"
export default component.exports